import Swiper from 'Swiper'
import Waypoint from 'exports?Waypoint!waypoints/lib/noframework.waypoints.js'

/**
 * EventSpacesSlider functionality.
 * @author Dayne Coulson-Hoffacker
 */
export default class EventSpacesSlider {
  /**
   * Constructs a new EventSpacesSlider instance.
   * @param {Object} options - Options.
   * @param {HTMLElement} options.element - Container.
   */
  constructor (options) {
    this.element = options.element
    this.swiperContainer = this.element.querySelector('.swiper-container')
    this.swiperPagination = this.element.querySelector('.swiper-pagination')
    this.swiperButtonPrev = this.element.querySelector('[data-component="swiper-button-prev"]')
    this.swiperButtonNext = this.element.querySelector('[data-component="swiper-button-next"]')

    const swiper = new Swiper(this.swiperContainer, {
      noSwiping: true,
      noSwipingClass: 'no-swiping',
      autoHeight: true,
      pagination: {
        el: this.swiperPagination,
        type: 'fraction',
      },
      autoplay: {
        delay: 3000,
        disableOnInteraction: false
      },
      effect: 'fade',
      loop: true,
      fadeEffect: {
        crossFade: true
      }
    })

    swiper.autoplay.stop()

    if (this.swiperButtonPrev) {
      this.swiperButtonPrev.addEventListener('click', () => {
        swiper.slidePrev()
      })
    }

    if (this.swiperButtonNext) {
      this.swiperButtonNext.addEventListener('click', () => {
        swiper.slideNext()
      })
    }

    const self = this
    new Waypoint({
      element: self.element,
      handler: () => {
        swiper.autoplay.start()
      },
      offset: '45%'
    })

  }
}



// WEBPACK FOOTER //
// ./components/events/event-spaces-slider/index.js